import type { OrderedStepLocal } from "@/services/dexie"
import type { SessionConfig, StepType } from "@/utils/types"

// List of step types that require photo/video capture and upload
const CAPTURE_STEP_TYPES: StepType[] = ["VehiclePhoto", "DocumentPhoto", "Damage", "VehicleVideo", "ExtraEquipment"]

/**
 * Session-wide: true if every capture-relevant step is upload-only.
 * Mirrors historical session-wide `forcedFilesystemPhotoUpload === true` semantics.
 * Used to gate permission prompts (camera + geo) and Windows device check.
 *
 * Virtual steps (Intro/DocumentsIntro/FinalCheck) are implicitly excluded by the stepType filter.
 */
export function arePermissionsDisabledForSession(steps: OrderedStepLocal[] | SessionConfig["orderedSteps"]): boolean {
  const captureSteps = steps.filter((s) => (CAPTURE_STEP_TYPES as readonly string[]).includes(s.stepType))
  if (captureSteps.length === 0) return false

  return captureSteps.every((s) => s.enableUpload === true)
}
